import FilterCard from 'Components/Editor/Details/Filters/FilterCard';
import FilterSlider from 'Components/Editor/Details/Filters/FilterSlider';
import { DetectionAreaSpecification } from 'Models/Project/ProjectFilterSpecifications';
import EditorVideoDetection from 'Models/Videos/Detections/EditorVideoDetection';
import { ReactElement } from 'react';

interface FilterCardAreaProps {
	area: DetectionAreaSpecification | null;
	onAreaChanged: (area: DetectionAreaSpecification | null) => void;
	selectedDetections: EditorVideoDetection[];
}

const INITIAL_AREA_VALUE: DetectionAreaSpecification = { from: 0, to: 0 };

const FilterCardArea = (props: FilterCardAreaProps): ReactElement => {
	const isChecked = props.area !== null;
	const fromValue = Math.round((props.area?.from ?? 0) * 10000) / 100;
	const toValue = Math.round((props.area?.to ?? 0) * 10000) / 100;

	const getValueLabelFormat = (value: number): string => {
		return `${value}%`;
	};

	const marks = Array.from(Array(9).keys()).map((x) => ({
		value: x * 20,
		label: `${x * 20}%`,
	}));

	const handlePlacementCardCheckedChanged = (checked: boolean): void => {
		const defaultValue = INITIAL_AREA_VALUE;
		if (props.selectedDetections.length > 0) {
			defaultValue.from = props.selectedDetections.reduce(
				(acc, x) => (x.area < acc ? x.area : acc),
				Number.MAX_SAFE_INTEGER
			);
			defaultValue.to = props.selectedDetections.reduce((acc, x) => (x.area > acc ? x.area : acc), 0);
		}
		if (checked) props.onAreaChanged(defaultValue);
		else props.onAreaChanged(null);
	};

	const setValues = (from: number, to: number): void => {
		props.onAreaChanged({ from: from / 100, to: to / 100 });
	};

	return (
		<FilterCard name="Select area" onCheckedChanged={handlePlacementCardCheckedChanged} isChecked={isChecked}>
			<FilterSlider
				label="Area"
				fromValue={fromValue}
				toValue={toValue}
				min={0}
				max={100}
				step={0.1}
				marks={marks}
				valueLabelFormat={getValueLabelFormat}
				onValuesChanged={setValues}
			/>
		</FilterCard>
	);
};

export default FilterCardArea;
